/*
 * GEHC CONFIDENTIAL
 *
 * Copyright (c) 2025, 2025, GE HealthCare
 * All Rights Reserved
 *
 * This unpublished material is proprietary to GE HealthCare. The methods and
 * techniques described herein are considered trade secrets and/or
 * confidential. Reproduction or distribution, in whole or in part, is
 * forbidden except by express written permission of GE HealthCare.
 * GE is a trademark of General Electric Company used under trademark license.
 */

export enum HealthCheckType {
  PINGPONG = 'PINGPONG'
}
export enum HealthStatus {
  HEALTHY = 'HEALTHY',
  UNHEALTHY = 'UNHEALTHY'
}
export enum HealthCommand {
  PING = 'PING',
  PONG = 'PONG'
}

export interface HealthRequest {
  type: HealthCommand;
  appId: string;
}

export interface HealthResponse extends HealthRequest {
  status: HealthStatus;
  lastSessionActive: string;
}
